import usePosOrderSetupHook from "@/shared/hooks/usePosOrderSetupHook";
import useResetPaymentLedgerHook from "@/shared/hooks/useResetPaymentLedgerHook";

const PosGlobal = () => {
  usePosOrderSetupHook();
  useResetPaymentLedgerHook();
  return null;
};

export default PosGlobal;
